export default defineNuxtRouteMiddleware((to) => {
  const { path, query, hash } = to

  // trailing slash
  if (path.endsWith('/')) return
  if (path.endsWith('.html')) return
  const nextPath = path + '/'
  const nextRoute = { path: nextPath, query, hash }
  return navigateTo(nextRoute, { redirectCode: 301 })
})
